import { NewCustomTablePageSchemaFieldFragment } from 'generated/resources/graphql'
import isNil from 'lodash/isNil'

import type Value from 'modules/custom_resources/store/models/customResources/Value'
import { defaultValue } from 'modules/employees/components/CustomResources/SchemaComponent/Form/utils/defaultValue'

type ReturnType = string | null | boolean | number | string[]

const coerceValueFromType = (
  field: NewCustomTablePageSchemaFieldFragment,
  fieldValue: Value
): ReturnType => {
  const id = field.id.toString()
  const value = fieldValue.attributes[id]

  if (isNil(value)) {
    return defaultValue(field.fieldType)
  }

  switch (field.fieldType) {
    case 'cents':
    case 'money':
      return +value

    default:
      return value
  }
}

export default coerceValueFromType
